import { DOCUMENT } from '@angular/common';
import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  EventEmitter,
  Inject,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { FormGroup } from '@angular/forms';
import { fromJS } from 'immutable';
import { Attachment } from '../../../attachments/attachment.model';
import { I2gNgTrackingActionBuilder } from 'i2g-ng-tracking';
import {
  ITrackingAction,
  ITrackingObject,
  TrackingScreenNamesEnum,
} from '../../../tracking/tracking.data';
import { AttachmentInfoFormBuilder } from './attachment-info-form.builder';

@Component({
  selector: 'app-attachment-info-form',
  templateUrl: './attachment-info-form.component.html',
  styleUrls: ['./attachment-info-form.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  viewProviders: [AttachmentInfoFormBuilder],
})
export class AttachmentInfoFormComponent
  implements OnInit, AfterViewInit, OnDestroy {
  @Input() attachment: Attachment;
  @Input() trackingScreenName: TrackingScreenNamesEnum;
  @Input() trackingObject: ITrackingObject;

  @Output()
  onUpdateAttachmentInfo: EventEmitter<Attachment> = new EventEmitter<Attachment>();
  @Output() onCancel: EventEmitter<Attachment> = new EventEmitter<Attachment>();

  private _el: any;
  private _originalFormValue: any;

  form: FormGroup;
  formKeys: any;
  attachmentProps: any;
  cancelTapped: ITrackingAction;
  saveTapped: ITrackingAction;

  constructor(
    @Inject(DOCUMENT) private _document: Document,
    private _elementRef: ElementRef,
    private _attachmentInfoFormBuilder: AttachmentInfoFormBuilder,
    private _trackingActionBuilder: I2gNgTrackingActionBuilder
  ) {}

  ngOnInit() {
    this._el = this._elementRef.nativeElement;
    this.form = this._attachmentInfoFormBuilder.buildForm(this.attachment);
    this.formKeys = this._attachmentInfoFormBuilder.FORM_KEYS;
    this._originalFormValue = this.form.value;
    this.attachmentProps = this._attachmentInfoFormBuilder.buildAttachmentProps(
      this.attachment.toMap()
    );

    this.cancelTapped = this._trackingActionBuilder.buildButtonTapped(
      'cancel_photo',
      this.trackingScreenName
    );
    this.saveTapped = this._trackingActionBuilder.buildButtonTapped(
      'save_photo',
      this.trackingScreenName
    );
  }

  ngAfterViewInit() {
    setTimeout(() =>
      this._document.addEventListener('click', this._handleClickOutsideCallback)
    );
  }

  saveEditingAttachment() {
    if (this.form.valid) {
      const attachmentProps = this._attachmentInfoFormBuilder.buildAttachmentProps(
        fromJS(this.form.value)
      );
      const newAttachment = this.attachment.setInfoFields(attachmentProps);

      this.onUpdateAttachmentInfo.emit(newAttachment);
    }
  }

  cancelEditing() {
    this.form.reset(this._originalFormValue);
    this.onCancel.emit(this._originalFormValue);
  }

  ngOnDestroy() {
    this._document.removeEventListener(
      'click',
      this._handleClickOutsideCallback
    );
  }

  private _handleClickOutside(evt: Event) {
    const evtTarget = evt.target;

    if (!evtTarget) {
      return;
    }

    if (!this._el.contains(evtTarget)) {
      this.saveEditingAttachment();
    }
  }

  private _handleClickOutsideCallback = this._handleClickOutside.bind(this);
}
